import classNames from 'classnames';
import React from 'react';
const Button = (props) => {
    const handleClick = (e) => {
        if (props.usesDefault != undefined && !props.usesDefault && props.onClick) {
            e.preventDefault();
        }
        props.onClick && props.onClick.call(this, e);
    };
    const handleKeyDown = (e) => {
        if (props.usesDefault != undefined && !props.usesDefault && props.onKeyDown) {
            e.preventDefault();
        }
        props.onKeyDown && props.onKeyDown.call(this, e);
    };
    return (React.createElement("button", { ref: props.reference, onClick: handleClick, onKeyDown: handleKeyDown, disabled: props.disabled, className: classNames('cta', props.cls, props.className, { loading: props.isLoading }), type: props.type, "aria-label": props.ariaLabel, style: props.style, tabIndex: props.tabIndex }, props.isLoading ? (React.createElement(React.Fragment, null,
        React.createElement("div", null))) : (React.createElement("span", { "data-label": props.dataLabel }, props.children))));
};
Button.defaultProps = {
    cls: ['cta-primary'],
    className: '',
};
export default Button;
